import BorderBottomCard from "@/features/dashboard/components/BorderBottomCard";
import CommonSelect from "@/shared/components/ui/Select/CommonSelect";
import CustomSwitch from "@/shared/components/ui/Switch/CustomSwitch";

const SelectDeliverabilityField = ({
  field,
  value,
  onChange,
  index,
  length,
}) => {
  const isReadOnlyCampaignLimit = field.key === "campaignContactsPerDayLimit";
  const isDisabled = field.disabled || isReadOnlyCampaignLimit;
  const normalizedOptions = Array.isArray(field.options) ? field.options : [];
  const optionsWithValue =
    field.type !== "toggle" &&
      field.type !== "text" &&
      value != null &&
      !normalizedOptions.includes(value)
      ? [value, ...normalizedOptions]
      : normalizedOptions;

  return (
    <BorderBottomCard
      className={`p-0 py-1.5 ${index === length - 1 ? "border-b-0" : ""}`}
    >
      <div
        className={`
      flex flex-col sm:flex-row
      justify-between
      gap-3 sm:gap-4
      w-full
      ${field.type === "toggle" ? "sm:items-start" : "sm:items-center"}
    `}
      >
        {/* Label Section */}
        <div className="flex flex-col flex-1 min-w-0">
          <h4 className="text-sm font-normal text-gray-800 break-words">
            {field.label}
          </h4>

          {field.helperText && (
            <p className="text-xs text-gray-500 font-normal break-words">
              {field.helperText}
            </p>
          )}
        </div>

        {/* Control Section */}
        <div
          className={`
        w-full sm:w-auto
        flex
        justify-start sm:justify-end
        shrink-0
      `}
        >
          {field.type === "toggle" ? (
            <CustomSwitch
              aria-label={field.label}
              value={value}
              size="sm"
              onChange={(val) => onChange(field.key, val)}
            />
          ) : field.type === "text" ? (
            <div className="flex items-center gap-2 w-full sm:w-auto">
              <CommonSelect
                width="w-full sm:w-[70px]"
                ariaLabel={field.label}
                options={[
                  {
                    label: String(value ?? 0),
                    value: value ?? 0,
                  },
                ]}
                value={value ?? 0}
                classNames={{
                  base: "bg-white w-full",
                  trigger:
                    "bg-white border border-gray-200 shadow-none w-full",
                }}
                onChange={() => { }}
                disabled
              />

              {field.suffix && (
                <p className="text-sm text-gray-500 whitespace-nowrap">
                  {field.suffix}
                </p>
              )}
            </div>
          ) : (
            <div className="flex items-center gap-2 w-full sm:w-auto">
              <CommonSelect
                width="w-full sm:w-[70px]"
                ariaLabel={field.label}
                options={optionsWithValue.map((v) => ({
                  label: String(v),
                  value: v,
                }))}
                value={value}
                classNames={{
                  base: "bg-white w-full",
                  trigger:
                    "bg-white border border-gray-200 shadow-none w-full",
                }}
                onChange={(val) => {
                  if (isDisabled) return;
                  onChange(field.key, val);
                }}
                disabled={isDisabled}
              />

              {field.suffix && (
                <p className="text-sm text-gray-500 whitespace-nowrap">
                  {field.suffix}
                </p>
              )}
            </div>
          )}
        </div>
      </div>
    </BorderBottomCard>
  );
};

export default SelectDeliverabilityField;
